'use client';

import { forwardRef, type HTMLAttributes } from 'react';
import Link from 'next/link';
import { useTheme } from 'next-themes';

import { cn } from '@/lib/utils';

import { LocalImage } from '@/components/atoms/LocalImage';
import { ButtonsFactory } from '@/components/molecules/ButtonsFactory';
import { DesktopList } from '@/components/organisms/Navigation/components/desktop/DesktopList';
import type { NavigationConfigType } from '@/components/organisms/Navigation/Navigation.types';

interface DesktopNavigationProps
    extends HTMLAttributes<HTMLDivElement>,
        NavigationConfigType {
    location: string;
}

const DesktopNavigation = forwardRef<HTMLElement, DesktopNavigationProps>(
    ({ location, links, buttons, className }, ref) => {
        const { forcedTheme } = useTheme();

        return (
            <nav
                ref={ref}
                className={cn(
                    'container flex w-full flex-row justify-between',
                    className,
                )}
            >
                <div className="flex items-center gap-x-3">
                    <Link
                        href="/"
                        // onClick={() => {
                        //     Sentry.addBreadcrumb({
                        //         category: 'navigation',
                        //         message: 'click to menu link /',
                        //         level: 'info',
                        //     });
                        // }}
                    >
                        <LocalImage
                            src={`/images/logos/${forcedTheme === 'dark' ? 'logo-white.svg' : 'logo.svg'}`}
                            alt="PayPo logo"
                            width={141}
                            height={40}
                        />
                    </Link>

                    <DesktopList
                        links={links}
                        location={location}
                    />
                </div>

                {!!buttons && (
                    <ButtonsFactory
                        className="w-fit gap-3"
                        config={buttons}
                    />
                )}
            </nav>
        );
    },
);

export default DesktopNavigation;
